import React from "react";
import { Box, Typography } from "@mui/material";

const SessionBuildHeader = ({ firstRow }) => (
  <Box
    sx={{
      mb: 1,
      paddingRight: 2,
      pt: 1,
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      width: "100%",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%" }}>
      <Typography variant="h4" className="step7-title">
        Secuencia SAC
      </Typography>
      <Box sx={{ borderLeft: "1px solid #9e9e9e", height: "30px", marginLeft: 2, marginRight: 2 }} />
      <Typography variant="body2" sx={{ color: "#9e9e9e", maxWidth: 420 }}>
        Revisión y generación de Sesión
      </Typography>
    </Box>

    <Box className="step7-meta-compact">
      <Box className="step7-meta-line">
        <div>
          <span className="step7-meta-label">Nivel</span>
          <span className="step7-meta-value">{firstRow?.nivelNombre || "-"}</span>
        </div>
        <div>
          <span className="step7-meta-label">Grado</span>
          <span className="step7-meta-value">{firstRow?.gradoNombre || "-"}</span>
        </div>
      </Box>

      <Box className="step7-meta-line">
        <div>
          <span className="step7-meta-label">Área Temática</span>
          <span className="step7-meta-value">{firstRow?.areaNombre || "-"}</span>
        </div>
        <div>
          <span className="step7-meta-label">Unidad</span>
          <span className="step7-meta-value">{firstRow?.unidadNombre || firstRow?.unidad || "-"}</span>
        </div>
      </Box>
    </Box>
  </Box>
);

export default SessionBuildHeader;
